import React, { useState } from "react";
import { DropDownNav } from "../MyComponents/MyNavComponents";
import { NavLink } from "react-router-dom";
import { Nav } from "reactstrap";
import { Translate } from "../../helpers/Translate";
import { transcode } from "buffer";
import jwt_decode from "jwt-decode";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store/index";
import $ from "jquery";

import Cookies from "js-cookie";
// function getMenu(props:MenuItem){
//   let t = new Translate();
//     const subMenu = props.MenuItems.map((m:MenuItem) => {
//             return(
//                 getMenu(m)
//             );
//     });
//     const pages = props.Pages.map((p:Page) => {
//       return(
//       <NavLink key={p.PageId} className="nav-link" to={"/dashboard/"+p.Name.replace(" ","")}>{t.translate(p.Name)}</NavLink>
//       );
//     });

//   return(
//     <DropDownNav key={props.MenuItemId} name={props.Name} className="fa fa-lock">
//       {subMenu}
//       {pages}
//     </DropDownNav>
//   );
// }
interface MenuItem {
  MenuItemId: number;
  Name: string;
  MenuItems: Array<MenuItem>;
  Pages: Array<Page>;
}
interface Page {
  PageId: number;
  Name: string;
}

export default function SideNav(props: any) {
  let t = new Translate();
  const user = useSelector((state: ApplicationState) => state.user);

  // Check if user is NOT a student
  const isNotStudent = (user as any)?.userRole?.rolename !== "Student";

  // const subMenu = props.Menu.MenuItems.map((m:MenuItem) => {
  //         return(
  //             getMenu(m)
  //         );
  // });
  {
    /*<NavLink  className="nav-link" to={"/dashboard/users"} key ="1"> Users</NavLink>,*/
  }
  const token = Cookies.get("quiztoken");
  let decodedToken: any = {};

  decodedToken = jwt_decode(token || "");

  const pages = [
    <NavLink key="3" className="nav-link" to={"/dashboard/assessments"}>
      <div className="sb-nav-link-icon">
        <i className="fa fa-book"></i>
      </div>
      Assessments
    </NavLink>,
  ];

  const closeSidebar = () => {
    $("body").removeClass("sb-sidenav-toggled");
  };

  return (
    <div id="layoutSidenav_nav">
      <nav
        className="sb-sidenav accordion sb-sidenav-dark"
        id="sidenavAccordion"
      >
        <div className="sb-sidenav-menu">
          {/* Close button for mobile */}
          <button
            className="btn btn-link text-white d-lg-none position-absolute"
            onClick={closeSidebar}
            style={{
              top: "10px",
              right: "10px",
              fontSize: "1.5rem",
              zIndex: 1000,
              padding: "0.25rem 0.5rem",
            }}
            aria-label="Close sidebar"
          >
            <i className="fa fa-times"></i>
          </button>
          <Nav className="nav">
            {isNotStudent && (
              <>
                {/* <NavLink key="1" className="nav-link" to="/" exact>
                  <div className="sb-nav-link-icon">
                    <i className="fa fa-home"></i>
                  </div>
                  {t.translate("Home")}
                </NavLink> */}
                <NavLink key="2" className="nav-link" to="/PendingExams">
                  <div className="sb-nav-link-icon">
                    <i className="fa fa-tasks"></i>
                  </div>
                  {t.translate("pending Assignments")}
                </NavLink>
              </>
            )}
            {pages}

            {/*             <div className="sb-sidenav-menu-heading">Addons</div>
            <NavLink className="nav-link" to="charts.html">
              <div className="sb-nav-link-icon"><i className="fa fa-area-chart"></i></div>
            Charts
          </NavLink>
            <NavLink className="nav-link" to="tables.html">
              <div className="sb-nav-link-icon"><i className="fa fa-table"></i></div>
            Tables
            </NavLink> */}
          </Nav>
        </div>
      </nav>
    </div>
  );
}
